import renderDefaultField from './renderDefaultField'
import renderSelectField from './renderSelectField'
import renderPasswordField from './renderPasswordField'
import renderAutoAddressField from './renderAutoAddressField'
import renderCountryField from './renderCountryField'
import renderExpDateField from './renderExpDateField'

const fieldRenderers = {
    password: renderPasswordField,
    AutoAddress: renderAutoAddressField,
    CountryBox: renderCountryField,
    ExpDate: renderExpDateField,
    select: renderSelectField,
    default: renderDefaultField
}

export { fieldRenderers, renderDefaultField, renderSelectField, renderPasswordField, renderAutoAddressField, renderCountryField, renderExpDateField }

export default fieldRenderers

